export const shadow = {
  card: "rgba(0, 0, 0, 0.1) 0px 4px 12px;",
};
